import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="red" d="M22.438 16.546l.828-.81 2.688-2.688-1.946-1.84c-.091 0-2.633 2.542-2.633 2.542l-.833.844-2.57 2.527-2.472-2.449-.832-.812-2.666-2.643-1.97 1.842 2.656 2.636.828.803L16.08 19l-2.439 2.457-.828.806-2.781 2.75 1.96 1.779 2.631-2.542.83-.832 2.518-2.5 3.891 3.85.252.252 1.882 1.767 1.958-1.802-1.891-1.828-1.656-1.653-2.484-2.487 2.515-2.471zM17.986 19z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/close.svg